import { NgModule } from '@angular/core';
import { AssistanceComponent } from './assistance.component';
import { BlockPageAuthGuard, BrowserGuard } from 'src/app/utils/authguard';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/app/material/material.module';
import { RouterModule } from '@angular/router';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ServicenowFormComponent } from './servicenow-form/servicenow-form.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ErrorMessageComponent } from '../shared/error-message/error-message.component';
import { FileDropComponent } from '../shared/file-drop/file-drop.component';
import { FileDropContentTemplateDirective } from '../shared/file-drop/templates.directive';

const routes = [
  {
    path: 'assistance',
    component: AssistanceComponent,
    canActivate: [BrowserGuard, BlockPageAuthGuard],
  },
];

@NgModule({
  declarations: [AssistanceComponent, ServicenowFormComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatButtonToggleModule,
    ErrorMessageComponent,
    FileDropComponent,
    FileDropContentTemplateDirective,
  ],
  exports: [AssistanceComponent, ServicenowFormComponent],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class AssistanceModule {}
